import {InputDirective} from "../input.directive";
import {ChangeDetectorRef, Directive, ElementRef, Inject, OnInit, Optional, Renderer2, Self} from "@angular/core";
import {FormControlName} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {LoadingState} from "../state/loading-state.service";
import {InputType} from "../root/input-type"
import {StringValidator} from "../../../utils/validators";

@Directive({
  selector: "input[valgPostalCodeInput]",
  providers: [{ provide: InputType, useExisting: PostalCodeInputDirective },
  ]
})
export class PostalCodeInputDirective extends InputDirective implements OnInit {

  override errorKey = 'standard_input.postal_code_input';

  constructor(
      @Optional() @Self() @Inject(FormControlName) protected override formControl: FormControlName,
      protected override cdr: ChangeDetectorRef,
      protected override elementRef: ElementRef<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
      protected override renderer: Renderer2,
      protected override translate: TranslateService,
      protected override loadingState: LoadingState
  ) {
    super(formControl, cdr, elementRef, renderer, translate, loadingState);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.formControl.control?.addValidators([
      StringValidator.danishPostalCode,
    ]);
  }
}
